// Global arrays to track active players to more easily control.
const youTubePlayerArr = []
const vimeoPlayerArr = []
const internalPlayerArr = []

const addPlayerToTrackingArr = (source, player) => {
  if (source === "youtube") {
    youTubePlayerArr.push(player)
  }

  if (source === "vimeo") {
    vimeoPlayerArr.push(player)
  }

  if (source === "internal") {
    internalPlayerArr.push(player)
  }
}

/**
 * If a video is played, any previously started video will pause
 * If a slide (scroll slider or media lightbox) changes, a playing video will pause
 */
const pausePlayingVideos = () => {
  youTubePlayerArr.forEach((player) => {
    player.pauseVideo()
  })

  vimeoPlayerArr.forEach((player) => {
    player.pause()
  })

  internalPlayerArr.forEach((player) => {
    player.pause()
  })
}

const clearPlayerTrackingArr = () => {
  youTubePlayerArr.length = 0
  vimeoPlayerArr.length = 0
  internalPlayerArr.length = 0
}

/*
  YouTube specific state control
-------------------------------------------------------------------------- */
/**
 * Use YouTube player functions to alter settigns and state if poster clicked
 * @param {HTMLIFrameElement} player result of YT.Player
 *
 */
const clickPosterToPlayYouTube = (player) => {
  // Clicking the play button will play video with sound
  // This should true for mobile, safari, and low power mode
  if (!player) return

  player.unMute()
  player.playVideo()
}

const onYouTubePlayerStateChange = (event) => {
  // -1 is 'unstarted' likely due to API not being fully loaded
  if (event.data === -1) {
    event.target.mute()
    event.target.playVideo()
  }

  youTubePlayerArr.forEach((player) => {
    // Don't pause most recently played video, 1 = playing
    if (player !== event.target && event.data === 1) {
      player.pauseVideo()
    }
  })

  vimeoPlayerArr.forEach((player) => {
    player.pause()
  })

  internalPlayerArr.forEach((player) => {
    player.pause()
  })
}

/*
  Vimeo specific state control
-------------------------------------------------------------------------- */

/**
 * Use Vimeo player functions to alter settings and state if poster clicked
 * @param {HTMLIFrameElement} player result of Vimeo.Player
 *
 */
const clickPosterToPlayVimeo = (player) => {
  // Clicking play button will play video with sound
  // except on mobile, which will be muted or requires click to play in low power mode
  if (!player) return

  player.getPaused().then(function (paused) {
    if (paused) {
      player.play()
    } else {
      player.setMuted(true)
      player.play()
    }
  })
}

export {
  addPlayerToTrackingArr,
  pausePlayingVideos,
  onYouTubePlayerStateChange,
  clickPosterToPlayVimeo,
  clickPosterToPlayYouTube,
  clearPlayerTrackingArr,
}
